let ticketModalReady = false;

const eventId = '853793648787';
const onOrderComplete = () => null;

function loadEventBriteScript(): Promise<void> {
	if (ticketModalReady === true) {
		return Promise.resolve();
	}
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.onerror = reject;
		script.onload = () => {
			ticketModalReady = true;
			resolve();
		}
		script.src = 'https://www.eventbrite.com/static/widgets/eb_widgets.js';
		document.body.appendChild(script);
	});
}

export function initEventBrite(modalTriggerElementId: string) {
	loadEventBriteScript().then(() => {
		(window as any).EBWidgets.createWidget({
			widgetType: 'checkout',
			eventId,
			modal: true,
			modalTriggerElementId,
			onOrderComplete
		});
	});
}